import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "IceOssUploaderContainer"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "el-upload-list el-upload-list--picture-card"
};
const _hoisted_4 = {
  class: "bothCenter colFlex"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "el-upload-list__item-actions"
};
const _hoisted_9 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  const _component_Delete = _resolveComponent("Delete");
  const _component_draggable = _resolveComponent("draggable");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_upload, {
    "list-type": "picture-card",
    "auto-upload": true,
    multiple: true,
    "http-request": $options.uploadRequest,
    "file-list": $data.files,
    "show-file-list": false,
    ref: "uploader",
    "on-success": r => $options.handleImageUploadSuccess(r.url, r),
    "on-remove": d => $options.handleUploadImageRemove(d)
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Plus)]),
      _: 1
    })]),
    _: 1
  }, 8, ["http-request", "file-list", "on-success", "on-remove"]), _createVNode(_component_DialogCustomView, {
    style: {
      "width": "500px"
    },
    onClose: _cache[0] || (_cache[0] = $event => $data.preview = false),
    "visible-control": $data.preview,
    title: "预览图片"
  }, {
    default: _withCtx(() => [$data.preview ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: $data.preivewImg
    }, null, 8, _hoisted_2)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["visible-control"])]), _createElementVNode("ul", _hoisted_3, [_createVNode(_component_draggable, {
    modelValue: $data.files,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.files = $event),
    onChange: $options.draggableChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.files, (file, index) => {
      return _openBlock(), _createElementBlock("li", {
        key: index,
        class: "el-upload-list__item is-success animated"
      }, [_createElementVNode("div", _hoisted_4, [$options.isMp4(file) ? (_openBlock(), _createElementBlock("video", {
        key: 0,
        src: file.url,
        controls: "",
        style: {
          "width": "100%"
        }
      }, null, 8, _hoisted_5)) : $options.isImage(file) ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: file.url,
        class: "el-upload-list__item-thumbnail"
      }, null, 8, _hoisted_6)) : (_openBlock(), _createElementBlock("img", {
        key: 2,
        src: $options.getFileIcon(file),
        class: "el-upload-list__item-thumbnail"
      }, null, 8, _hoisted_7)), _createElementVNode("span", _hoisted_8, [_createElementVNode("span", {
        class: "el-upload-list__item-delete",
        onClick: $event => $options.handleRemove(file)
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Delete)]),
        _: 1
      })], 8, _hoisted_9)])])]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])])], 64);
}